const FrontPage = () => {
  return (
    <div id="home" className="frontpage-container">
      <div className="frontpage-child">
        <h1>Madeline Corman</h1>
      </div>
      <div className="frontpage-child">
        <p>
          A full stack software engingeer dedicated to building beautiful,
          effective solutions.
        </p>
      </div>
    </div>
  );
};

export default FrontPage;
